import styled, { css } from 'styled-components';

import {
	heading1, heading2, heading3, heading4, heading5, heading6,
} from '../../assets/styles/text';
import {
	dontWrapWhiteSpace, mobileOptions, textAlign, padding, margin, maxWidth, textColors, fontWeight,
} from '../../assets/styles/props';

const properties = css`
	${padding};
	${margin};
	${textAlign};
	${maxWidth};
	${dontWrapWhiteSpace};
	${mobileOptions};
	${textColors};
	${fontWeight};
`;

const headings = {
	h1: heading1,
	h2: heading2,
	h3: heading3,
	h4: heading4,
	h5: heading5,
	h6: heading6,
};

export const Heading = styled.h1`
	${(props) => {
		if (props.as) {
			return css`
				${headings[props.as]};
				> a {
					${headings[props.as]};
					${textColors};
				}
			`;
		}
		return heading1;
	}};
	
	${properties};
`;

Heading.defaultProps = {
	textColor: 'heading',
};
